import { ButtonAction } from 'pages/NotifyEvent/styles';

export interface IBackTreatment {
  forwardToFinish({ type }: {
    type: 'forward' | 'finish';
  }): void
  actionsBack: string
  rendered: boolean
}

export default function BackTreatment({ forwardToFinish, actionsBack, rendered }: IBackTreatment) {
  if (!rendered) return null
  return (
    <ButtonAction
      data-testid="test-back-button"
      type="button"
      onClick={() => forwardToFinish({ type: 'forward' })}
      onKeyUp={(e) => e.key === 'ArrowLeft' && forwardToFinish({ type: 'forward' })}
      className={actionsBack}
    >
      Voltar
    </ButtonAction>
  )
}
